import dashboardServices from "../services/hoa-dashboard-api-service";
import datastore from "../store/hoa-datastore";
import { saveNewLogsInDatastore } from "../utility/change-log";

export default function useCreateLogs() {
	const createLogsForNonAssignableMail = async (id: string, organization: any) => {
		const events: any = [];
		const primaryEvent = `Mail Marked as Non-Assignable`;
		const billableItem = "Mail Processing";
		events.push(primaryEvent);

		if (events.length > 0) {
			const logMessage = {
				events: events,
				billItem: billableItem ? billableItem : "",
				evidenceLink: "",
				user: datastore.ownerInformation.name,
				prevState: {},
				updatedState: {},
				type: "Mail",
				tagTypeId: id,
				nonAssignOrg: organization,
			};

			await createLogsAsync(logMessage);
		}
	};

	const revertNonAssignableMailLog = async (id: string) => {
		return await dashboardServices.updateCreatedLastHoaAppLog(id, "Mail", 0);
	};

	const createLogsAsync = async (logMessage: any) => {
		const result = await dashboardServices.createLogs(logMessage);
		saveNewLogsInDatastore(result.data, datastore);
	};

	const createLogsForNonAssignableEmail = async (id: string, nonAssignedEmailOrg:string) => {
		const events: any = [];
		const primaryEvent = `Email Marked as Non-Assignable`;
		const billableItem = "Email Processing";
		events.push(primaryEvent);

		if (events.length > 0) {
			const logMessage = {
				events: events,
				billItem: billableItem ? billableItem : "",
				evidenceLink: "",
				user: datastore.ownerInformation.name,
				prevState: {},
				updatedState: {},
				type: "Email",
				tagTypeId: id,
				nonAssignOrg: { id : nonAssignedEmailOrg },
			};

			await createLogsAsync(logMessage);
		}
	};

	const revertNonAssignableEmailLog = async (id: string) => {
		return await dashboardServices.updateCreatedLastHoaAppLog(id, "Email", 0);
	};

	const revertAddClientLog = async(hoaId: string, clientIds: any) => {
		const events: any = [];
		clientIds.forEach((clientId: any) => {
			const primaryEvent = `Organization Assigned to HOA (${clientId})`;
			events.push(primaryEvent);
		});
		const billableItem = "Not Billable";
		const billAmount = 0;
		const data = {
			events: events,
			billItem: billableItem,
			billAmount: billAmount,
			type: "Hoa",
			tagTypeId: hoaId,
			updatedBy: datastore.ownerInformation.name,
		}
		return await dashboardServices.revertAddClientLog(data);
	}

	return {
		createLogsForNonAssignableMail,
		revertNonAssignableMailLog,
		createLogsForNonAssignableEmail,
		revertNonAssignableEmailLog,
		revertAddClientLog
	};
}
